/*
 * @Author: Teemo Ding
 * @Date: 2022-09-01 15:25:16
 * @LastEditTime: 2022-09-01 16:29:50
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/GiftCard/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import css from './css.module.less';
import { get } from 'lodash';
import { OriCheckbox as Checkbox } from 'src/components/Antd/Checkbox/Checkbox';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const GiftCard = ({ data, onChange, setHasModified, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const enabled = get(data, 'enabled');
  const handleOnChange = (e) => {
    setHasModified(true);
    const enabled = e.target.checked;
    if (onChange) {
      onChange({ enabled });
    }
  };

  return (
    <SectionWrapper
      title={getI18n('salesChannelCheckout.index.checkoutGiftCard')}>
      <Checkbox
        checked={enabled}
        onChange={handleOnChange}
        disabled={disableEdit}
        className={css.checkbox}>
        {getI18n('salesChannelCheckout.index.enablecheckoutgiftcard')}
      </Checkbox>
    </SectionWrapper>
  );
};

export default GiftCard;
